import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';

const STEPS = [
    {
        title: "AI-Generated Text",
        icon: (
            <div className={styles.iconWrapper}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    className={styles.aiDocumentIcon}
                >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
            </div>
        )
    },
    {
        title: "Stealth Model Processing...",
        icon: (
            <div className={styles.iconWrapper}>
                <div className={styles.spinner}></div>
            </div>
        )
    },
    {
        title: "Undetectable Human Text",
        icon: (
            <div className={styles.iconWrapper}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    className={styles.humanDocumentIcon}
                >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <svg 
                    fill="currentColor" 
                    viewBox="0 0 16 16" 
                    xmlns="http://www.w3.org/2000/svg" 
                    className={styles.checkmarkIcon}
                >
                    <path d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z"></path>
                </svg>
            </div>
        )
    }
];

export const StealthModelAnimation = () => {
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentStep((prevStep) => (prevStep + 1) % STEPS.length);
        }, 1500); // Change step every 1.5 seconds

        return () => clearInterval(interval);
    }, []);

    const { title, icon } = STEPS[currentStep];

    return (
        <div className={styles.animationContainer}>
            <div className={styles.header}>
                <span className={styles.dot} style={{ backgroundColor: '#ff5f57' }}></span>
                <span className={styles.dot} style={{ backgroundColor: '#ffbd2e' }}></span>
                <span className={styles.dot} style={{ backgroundColor: '#28ca41' }}></span>
            </div>
            <div className={styles.content}>
                <h4 className={styles.title}>{title}</h4>
                <div className={styles.iconContainer}>
                    {icon}
                </div>
            </div>
            <div className={styles.progressBarContainer}>
                {STEPS.map((_, index) => (
                    <div
                        key={index}
                        className={`${styles.progressBarSegment} ${currentStep === index ? styles.active : ''}`}
                    />
                ))}
            </div>
        </div>
    );
};
